import React, { memo } from 'react'
import { View } from 'react-native'

import { MessageContainer } from 'APP/Converse/Chat/MessageContainer'
import { usePostContext } from 'APP/Lib/Context'
import TypingAnimation from './TypingAnimation'

const TypingIndicator: React.FC = () => {
  const { previousPostIsSameUser, nextPostIsSameUser, previousPostIsSameDay, nextPostIsSameDay } =
    usePostContext()

  return (
    <View style={{ alignItems: 'flex-start' }}>
      <MessageContainer
        rtl={false}
        previousPostIsSameUser={previousPostIsSameUser}
        nextPostIsSameUser={nextPostIsSameUser}
        previousPostIsSameDay={previousPostIsSameDay}
        nextPostIsSameDay={nextPostIsSameDay}
      >
        <TypingAnimation />
      </MessageContainer>
    </View>
  )
}

export default memo(TypingIndicator)
